/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsConfirmationDetailSummaryRoutes {
  ROUTE_PRINT = '/print',
}
export { PseudonymAppointmentsConfirmationDetailSummaryRoutes };
